import { ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { SessionService } from '../../services/account-service/session.service';
import { MainHeaderComponent } from '../../components/main-header/main-header.component';

@Component({
  selector: 'app-main-page-layout',
  standalone: true,
  imports: [RouterLink, RouterOutlet, MainHeaderComponent],
  templateUrl: './main-page-layout.component.html',
  styleUrl: './main-page-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainPageLayoutComponent implements OnDestroy {
  // Private variables

  // Public properties

  // Constructors

  constructor(
    public readonly session: SessionService,
    private readonly viewportScroller: ViewportScroller,
    private readonly element: ElementRef<HTMLElement>
  ) {
    // Recalculate for wrapped navigation and enlarged text before each anchor jump.
    this.viewportScroller.setOffset(() => {
      const header = this.element.nativeElement.querySelector('app-main-header');
      return [0, (header?.getBoundingClientRect().height ?? 0) + 16];
    });
  }

  // Public methods

  ngOnDestroy(): void {
    this.viewportScroller.setOffset([0, 0]);
  }

  // Private methods
}
